import React from 'react';
import styles from './EmployeeManagement.module.scss';

const EmployeeManagement = () => {
  return <div className={styles.title}>Страница в разработке</div>;
};

export default EmployeeManagement;
